import { useMemo } from 'react';

import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';

import type { FeedTab } from './feed.state';

export const FEED_TABS: FeedTab[] = [
  'allArticles',
  'trends',
  'businessOpportunity',
  'materials',
];

export const useFeedTabIds = (): FeedTab[] => {
  const { hasRequiredProduct } = useUserProducts();
  const hasFeedSpotlightTab = hasRequiredProduct(PRODUCT.SPOTLIGHT);

  return useMemo(() => {
    if (hasFeedSpotlightTab) {
      return ['spotlight', ...FEED_TABS];
    }

    return FEED_TABS;
  }, [hasFeedSpotlightTab]);
};

export const useFeedTabsConfig = (): Array<{ id: FeedTab }> => {
  return useFeedTabIds().map(id => ({ id }));
};

export const useDefaultFeedTab = (): FeedTab => {
  const { hasRequiredProduct } = useUserProducts();

  if (hasRequiredProduct(PRODUCT.SPOTLIGHT)) {
    return 'spotlight';
  }

  return 'allArticles';
};
